import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'ark-loader-inline',
  templateUrl: './loader-inline.component.html',
  styleUrls: ['./loader-inline.component.scss'],
})
export class LoaderInlineComponent {
  @Input() color: 'light' | 'cta'| 'confirmed' | 'dark' = 'cta';

  constructor() {}
}
